import { z } from 'zod';

/** Vista del seller de Mercado Libre; los tokens llegan enmascarados del back. */
export interface MeliSeller {
  sellerId: string;
  nickname: string | null;
  isActive: boolean;
  businessCommerceId: string | null;
  accessTokenMask: string | null;
  refreshTokenMask: string | null;
  hasRefreshToken: boolean;
  lastSyncAt: string | null;
  updatedAt: string | null;
}

/** Seller tal como lo lista meli integra en `GET /sellers`. */
export interface MeliSellerListItem {
  id: string;
  userNickName: string | null;
  isActive: boolean;
  businessCommerceId: string | null;
}

export interface CommerceMeliIntegration {
  commerceId: string;
  /** api_code (o external_id si no tiene) del comercio: la clave con la que el micro guarda el vínculo. */
  commerceCode: string;
  linked: boolean;
  seller: MeliSeller | null;
  sellers: MeliSeller[];
}

export const meliIntegrationSchema = z.object({
  sellerId: z
    .string()
    .trim()
    .min(1, 'El Seller ID de Mercado Libre es obligatorio')
    .regex(/^\d+$/, 'El Seller ID debe ser numérico'),
  accessToken: z
    .string()
    .trim()
    .min(1, 'El access token de Mercado Libre es obligatorio'),
  refreshToken: z.string().trim().optional(),
  nickname: z.string().trim().optional(),
});

export type MeliIntegrationSchema = z.infer<typeof meliIntegrationSchema>;

export const defaultMeliIntegrationValues: MeliIntegrationSchema = {
  sellerId: '',
  accessToken: '',
  refreshToken: '',
  nickname: '',
};
